import React from 'react';
import PorpsType from 'prop-types';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';

const MenuProduct = (props) => {
    const history = useHistory();
    const { logo, name, url1, url2, description, enableButton, is_main_product, closeMenu } = props;
    return (
        <div className="menu-product-container">
            <img style={{ maxHeight: '100px', objectFit: 'contain' }} src={logo} alt={name} />
            <p className="description">{description}</p>
            {enableButton && (
                <>
                    <Button
                        test_id="menu_product_browse_car"
                        className="megaMenuBtn browse-button"
                        type="primary"
                        shape="round"
                        size="large"
                        onClick={() => {
                            if (is_main_product) {
                                closeMenu(false);
                                history.push(url1);
                            } else {
                                window.open(url1);
                            }
                        }}
                    >
                        Personal
                    </Button>

                    <Button
                        test_id="menu_product_business"
                        className="megaMenuBtn sfbBtn browse-button"
                        type="primary"
                        shape="round"
                        size="large"
                        onClick={() => {
                            if (is_main_product) {
                                closeMenu(false);
                                history.push(url2);
                            } else {
                                window.open(url2);
                            }
                        }}
                    >
                        Business
                    </Button>
                </>
            )}
        </div>
    );
};

MenuProduct.propsType = {
    name: PorpsType.string.isRequired,
    description: PorpsType.string.isRequired,
    enableButton: PorpsType.bool.isRequired,
};
MenuProduct.defaultProps = {
    enableButton: false,
};

export default MenuProduct;
